exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-sm { margin-top: 10px; }\r\n.no-padding { padding: 0; }\r\n.top-adjustment { padding-top: 4px; }\r\n/*--------------------*/\r\n* {\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .row::after {\r\n    content: \"\";\r\n    clear: both;\r\n    display: table;\r\n  }\r\n  html {\r\n    font-family: \"Lucida Sans\", sans-serif;\r\n  }\r\n  label {\r\n    padding: 10px 12px 10px 10px;\r\n    display: inline-block;\r\n  }\r\n  /* .container {\r\n    border-radius: 5px;\r\n    background-color: #f2f2f2;\r\n    padding: 10px;\r\n  } */\r\n  \r\n  \r\n  @media only screen and (min-width: 768px) {\r\n    /* For desktop: */\r\n    .col-1 {width: 8.33%;}\r\n    .col-2 {width: 16.66%;}\r\n    .col-3 {width: 25%;}\r\n    .col-4 {width: 33.33%;}\r\n    .col-5 {width: 41.66%;}\r\n    .col-6 {width: 50%;}\r\n    .col-7 {width: 58.33%;}\r\n    .col-8 {width: 66.66%;}\r\n    .col-9 {width: 75%;}\r\n    .col-10 {width: 83.33%;}\r\n    .col-11 {width: 91.66%;}\r\n    .col-12 {width: 100%;}\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/grevience/grevienceMangement.component.css
// module id = ../../../../../src/app/components/grevience/grevienceMangement.component.css
// module chunks = 0